import styled from "@emotion/styled";
import { type } from "@testing-library/user-event/dist/type";
import leftBg from "../../images/left-bg-box.png";
import rightBg from "../../images/base-bg-1.png";
import middleBg from "../../images/zh-middle.png";

type LayoutBoxProps = {
  leftWidth?: number | string;
  rightWidth?: number | string;
  middleWidth?: number | string;
};

const LayoutBox = styled.div<LayoutBoxProps>`
  width: 100%;
  display: flex;
  min-width: 1920px;
  .layout-left {
    position: relative;
    height: auto;
    z-index: 111111122;
    background-image: url(${leftBg});
    background-repeat: no-repeat;
    background-size: cover;
    padding-left: 20px;
    padding-top: 8px;
    flex: ${(props) =>
      props.leftWidth
        ? `0 0 ${
            typeof props.leftWidth === "number"
              ? props.leftWidth + "px"
              : props.leftWidth
          }`
        : 1};
  }
  .layout-middle {
    position: relative;
    z-index: 11111111;
    height: 0;
    /* background-image: url(${middleBg}); */
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: 10px;
    flex: ${(props) =>
      props.middleWidth
        ? `0 0 ${
            typeof props.middleWidth === "number"
              ? props.middleWidth + "px"
              : props.middleWidth
          }`
        : 1};
  }
  .layout-right {
    position: relative;
    z-index: 11111111;
    padding-top: 8px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${rightBg});
    padding-left: 20px;
    flex: ${(props) =>
      props.rightWidth
        ? `0 0 ${
            typeof props.rightWidth === "number"
              ? props.rightWidth + "px"
              : props.rightWidth
          }`
        : 1};
  }
  .layout-map {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
`;

type LayoutProps = {
  isFixed?: boolean;
  children?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
  map?: React.ReactNode;
  middleStyle?: React.CSSProperties;
} & LayoutBoxProps;

export const MainLayout: React.FC<LayoutProps> = ({
  children,
  left = null,
  right = null,
  map,
  leftWidth,
  rightWidth,
  middleWidth,
  middleStyle = {},
}) => {
  return (
    <LayoutBox
      leftWidth={leftWidth}
      middleWidth={middleWidth}
      rightWidth={rightWidth}
    >
      <div className="layout-left">{left}</div>
      <div className="layout-middle" style={middleStyle}>
        {children && children}
      </div>
      <div className="layout-right">{right}</div>
      {map && <div className="layout-map">{map}</div>}
    </LayoutBox>
  );
};
